import Swiper from 'swiper'

export default class SliderDouble {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const speed = 400

    const mainEl = this.el.querySelector('.slider-double--slider-main')
    if (!mainEl) return

    const secondaryEl = this.el.querySelector('.slider-double--slider-secondary')
    const textEl = this.el.querySelector('.slider-double--about-text')
    const slides = mainEl.querySelectorAll('.swiper-slide')

    const swiperSecondary = secondaryEl ? new Swiper(secondaryEl, {
      slidesPerView: 1,
      initialSlide: -1,
      loop: true,
      allowTouchMove: false,
      speed,
    }) : null

    const swiperText = textEl ? new Swiper(textEl, {
      slidesPerView: 1,
      initialSlide: -1,
      loop: true,
      allowTouchMove: false,
      autoHeight: true,
      speed,
    }) : null

    const swiperPrimary = new Swiper(mainEl, {
      slidesPerView: 1,
      speed,
      loop: true,
      initialSlide: 1,
      longSwipesRatio: 0.01,
      watchSlidesProgress: true,
    })

    if (swiperSecondary) {
      swiperPrimary.on('slideNextTransitionStart', () => swiperSecondary.slideNext())
      swiperPrimary.on('slidePrevTransitionStart', () => swiperSecondary.slidePrev())
    }

    if (swiperText) {
      swiperPrimary.on('slideNextTransitionStart', () => swiperText.slideNext())
      swiperPrimary.on('slidePrevTransitionStart', () => swiperText.slidePrev())
    }

    if (slides.length <= 1) {
      this.el.querySelectorAll('.slider-double--arrow').forEach(a => a.style.display = 'none')
      swiperPrimary.allowTouchMove = false
    } else {
      this.el.querySelector('.slider-double--arrow.prev')?.addEventListener('click', () => swiperPrimary.slidePrev())
      this.el.querySelector('.slider-double--arrow.next')?.addEventListener('click', () => swiperPrimary.slideNext())
    }
  }
}
